import * as React from 'react';
import { styled } from '@mui/material/styles';
import { vars } from '@mui/x-data-grid-pro/internals';
import useId from '@mui/utils/useId';
import composeClasses from '@mui/utils/composeClasses';
import { getDataGridUtilityClass } from '@mui/x-data-grid-pro';
import clsx from 'clsx';
import { useGridRootProps } from '../../hooks/utils/useGridRootProps';
import type { DataGridPremiumProcessedProps } from '../../models/dataGridPremiumProps';
import { useCollapsibleContext } from './CollapsibleContext';

export type CollapsiblePanelProps = React.HTMLAttributes<HTMLDivElement>;

type OwnerState = DataGridPremiumProcessedProps;

const useUtilityClasses = (ownerState: OwnerState) => {
  const { classes } = ownerState;

  const slots = {
    root: ['collapsiblePanel'],
  };

  return composeClasses(slots, getDataGridUtilityClass, classes);
};

const CollapsiblePanelRoot = styled('div', {
  name: 'MuiDataGrid',
  slot: 'CollapsiblePanel',
})<{ ownerState: OwnerState }>({
  border: `1px solid ${vars.colors.border.base}`,
  borderTop: 'none',
  borderBottomLeftRadius: vars.radius.base,
  borderBottomRightRadius: vars.radius.base,
  flex: 1,
  overflow: 'hidden',
});

function CollapsiblePanel(props: CollapsiblePanelProps) {
  const { 'aria-label': ariaLabel, children, className, ...other } = props;
  const rootProps = useGridRootProps();
  const classes = useUtilityClasses(rootProps);
  const id = useId();
  const { open } = useCollapsibleContext();

  if (!open) {
    return null;
  }

  return (
    <CollapsiblePanelRoot
      ownerState={rootProps}
      className={clsx(classes.root, className)}
      id={id}
      {...other}
    >
      {children}
    </CollapsiblePanelRoot>
  );
}

export { CollapsiblePanel };
